<template>
  <quill-editor :options="quillOptions" @change="onBodyUpdate" :content="body">
    <div
      :id="'ceTextToolbar-' + id"
      slot="toolbar"
      style="background-color: #EFEFEF;"
    >
      <span class="ql-formats">
        <button class="ql-bold">Bold</button>
        <button class="ql-italic">Italic</button>
        <button class="ql-list" value="bullet"></button>
      </span>
    </div>
  </quill-editor>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  props: ["id", "body"],
  components: { quillEditor },
  methods: {
    onBodyUpdate(body) {
      this.$emit("on-body-update", body.html);
    },
  },
  computed: {
    quillOptions() {
      return {
        modules: {
          toolbar: {
            container: "#ceTextToolbar-" + this.id,
          },
        },
        placeholder: "Beskriv artikelns innehåll i korthet",
      };
    },
  },
};
</script>

<style></style>
